"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../style/index.css");
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var is_IS_1 = __importDefault(require("antd/es/locale-provider/is_IS"));
var en_US_1 = __importDefault(require("antd/es/locale-provider/en_US"));
var locales_1 = __importDefault(require("../translations/locales"));
var moment_1 = __importDefault(require("moment"));
var react_intl_1 = require("react-intl");
var en_1 = __importDefault(require("react-intl/locale-data/en"));
var is_1 = __importDefault(require("react-intl/locale-data/is"));
var index_1 = __importDefault(require("./index"));
require("moment/locale/is");
/**
 * Component for creating a form for creating an invoice and submitting it to the MAPI transaction services
 *
 * @component
 */
var CreateInvoice = function (props) {
    var antLocale = is_IS_1.default;
    var languageString = "is";
    switch (props.language) {
        case "is":
            antLocale = is_IS_1.default;
            moment_1.default.locale("is");
            languageString = "is";
            break;
        case "en":
            antLocale = en_US_1.default;
            moment_1.default.locale("en");
            languageString = "en";
            break;
        default:
            antLocale = is_IS_1.default;
            moment_1.default.locale("is");
            languageString = "is";
            break;
    }
    localStorage.setItem("languageString", languageString);
    react_intl_1.addLocaleData(en_1.default.concat(is_1.default));
    return (react_1.default.createElement(antd_1.ConfigProvider, { locale: antLocale, componentSize: "small" },
        react_1.default.createElement(react_intl_1.IntlProvider, { locale: languageString, defaultLocale: "is", key: languageString, messages: locales_1.default[languageString] },
            react_1.default.createElement(index_1.default, { customers: props.customers, language: languageString, mapiBaseUrl: props.mapiBaseUrl, rapiBaseUrl: props.rapiBaseUrl, rapiApiKey: props.rapiApiKey, receiverRequirements: props.receiverRequirements, getReceiverRequirements: props.getReceiverRequirements, updateReceiverRequirementsProp: props.updateReceiverRequirementsProp, 
                // legalIdentifier={props.legalIdentifier}
                uploadSizeLimit: props.uploadSizeLimit, attachmentTooltipText: props.attachmentTooltipText, referenceIdentifiersHelpText: props.referenceIdentifiersHelpText, referenceIdentifiersLabelText: props.referenceIdentifiersLabelText, dueDateMinimumOffset: props.dueDateMinimumOffset, defaultPaymentType: props.defaultPaymentType }))));
};
exports.default = CreateInvoice;
